import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import ScrollToTop from 'components/Layouts/ScrollToTop';
import CategorieContext from 'context/CategorieContext';
import AppLayout from 'components/Layouts/AppLayout';
import { NavigationProvider } from 'context/NavigationContext';

ReactDOM.render(
  <React.StrictMode> 
    <CategorieContext>
      <BrowserRouter>
        <NavigationProvider>
          <AppLayout> 
            <ScrollToTop />
              <App />
          </AppLayout>
        </NavigationProvider>
      </BrowserRouter>
    </CategorieContext>   
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
